import { Component, OnInit } from '@angular/core';
import { AdminService, AdminCompaniesFilter } from '../../../../@shared/services/admin.service';
import { AdminCompanyResponse } from '../../../../@shared/models/response.module';

@Component({
  selector: 'app-admin-companies',
  standalone: false,
  templateUrl: './admin-companies.html',
  styleUrl: './admin-companies.css'
})
export class AdminCompanies implements OnInit {
  loading: boolean = true;
  companies: AdminCompanyResponse[] = [];
  Math = Math; // Make Math available in template

  // Pagination
  currentPage: number = 1;
  perPage: number = 20;
  totalItems: number = 0;
  totalPages: number = 0;

  // Filters
  searchQuery: string = '';
  companyType: string = '';
  activeOnly: boolean = false;
  sortBy: string = 'created_at';
  sortOrder: 'asc' | 'desc' = 'desc';

  companyTypes = [
    { value: '', label: 'All Types' },
    { value: 'stable', label: 'Stable' },
    { value: 'riding_club', label: 'Riding Club' },
    { value: 'riding_school', label: 'Riding School' },
    { value: 'stores_services', label: 'Stores & Services' }
  ];

  constructor(private adminService: AdminService) {}

  ngOnInit() {
    this.loadCompanies();
  }

  loadCompanies() {
    this.loading = true;

    const filters: AdminCompaniesFilter = {
      page: this.currentPage,
      per_page: this.perPage,
      order_by: this.sortBy,
      sort: this.sortOrder,
      compact: false
    };

    if (this.searchQuery) {
      filters.search = this.searchQuery;
    }

    if (this.companyType) {
      filters.company_type = this.companyType;
    }

    if (this.activeOnly) {
      filters.active_only = true;
    }

    this.adminService.getCompanies(filters).subscribe({
      next: (response) => {
        this.companies = response.data;
        this.totalItems = response.total_items;
        this.totalPages = response.total_pages;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onSearch() {
    this.currentPage = 1;
    this.loadCompanies();
  }

  onFilterChange() {
    this.currentPage = 1;
    this.loadCompanies();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadCompanies();
  }

  onSort(column: string) {
    if (this.sortBy === column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortBy = column;
      this.sortOrder = 'desc';
    }
    this.loadCompanies();
  }

  getSortIcon(column: string): string {
    if (this.sortBy !== column) return 'fa-sort';
    return this.sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  getCompanyTypeLabel(type: string | null): string {
    if (!type) return '-';
    const labels: { [key: string]: string } = {
      stable: 'Stable',
      riding_club: 'Riding Club',
      riding_school: 'Riding School',
      stores_services: 'Stores & Services'
    };
    return labels[type] || type;
  }

  getPages(): number[] {
    const pages: number[] = [];
    const maxPages = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
    let end = Math.min(this.totalPages, start + maxPages - 1);

    if (end - start + 1 < maxPages) {
      start = Math.max(1, end - maxPages + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}
